namespace $.$$ {
	export class $shm_showcase_demo_check_list extends $.$shm_showcase_demo_check_list {
		summary() { return this.selected().join( ', ' ) || 'Ничего не выбрано' }
	}
}
